<template>
  <v-app>
    <router-view></router-view>
    <vue-snotify></vue-snotify>
    <loader></loader>
  </v-app>
</template>

<script>
import loader from "../src/components/shared/loader.vue";

export default {
  name: "App",
  components: {
    loader
  },
  data: () => ({
    // IgnoreAutoLoginPaths: [
    //   '/register',
    //   '/thankyou',
    //   '/forgotpassword',
    //   '/new-password',
    //   '/client-unsubscribe',
    // ],
  }),
  methods: {
    
  },
  created() {
   

    // if (
    //   !this.IgnoreAutoLoginPaths.find((a) => this.$route.path.startsWith(a))
    // ) {
    //   this.$store.dispatch('tryAutoLogin');
    // }
  }
};
</script>
<style>
.v-event-timed-container {
  margin-right: 0.5% !important;
}
</style>
